import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface SIC {
    id: number;
    code: string;
    name: string;
}

export const sicApi = createApi({
  reducerPath: "sicApi",
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    getSICs: builder.query<SIC[], void>({
      query: () => "/sic/",
    }),
  }),
});

export const { useGetSICsQuery } = sicApi;
